import { api, VERSION } from './api';

export interface IOnboardingQuestionType {
  question: {
    id: string;
    title: string;
    description: string;
    step: number;
  };
  answers: {
    id: string;
    title: string;
    isConfident: boolean;
  }[];
}

export interface IOnboardingAnswerRequestType {
  question: string;
  answer: string;
  notes: string;
}

export const onboardingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOnboardingQuestions: build.query<IOnboardingQuestionType[], void>({
      query: () => `/user/${VERSION}/onboarding-questions`,
    }),
    postOnboardingAnswers: build.mutation<
      void,
      { onboardingAnswers: IOnboardingAnswerRequestType[]; isConfident: boolean | null }
    >({
      query(data) {
        return {
          url: `/user/${VERSION}/onboarding-answers`,
          method: 'POST',
          body: data,
        };
      },
    }),
    resendVerifyEmail: build.mutation<{ message: string }, void>({
      query: () => ({
        url: `/user/${VERSION}/email/verify/resend`,
        method: 'POST',
      }),
    }),
    unlockAccount: build.mutation<{ message: string }, void>({
      query: () => ({
        url: `/user/${VERSION}/account/unlock`,
        method: 'POST',
      }),
    }),
  }),
});

export const {
  useGetOnboardingQuestionsQuery,
  usePostOnboardingAnswersMutation,
  useResendVerifyEmailMutation,
  useUnlockAccountMutation,
} = onboardingApi;
